export function heroSlider() {
    let $slider = $(".hero-slider");
    let autoplaySpeed = $(".hero-slider").data("autoplay-speed");
    if (!autoplaySpeed) {
        autoplaySpeed = 5000;
    }
    $slider.slick({
        slidesToScroll: 1,
        fade: true,
        infinite: false,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: autoplaySpeed,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $slider.find(".title-animation").removeClass("animate");
    }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
        $slider.find(".title-animation").addClass("animate");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroSlider.js